export const LOAD_MOVIES_SUCCESS = "LOAD_MOVIES_SUCCESS";
export type LOAD_MOVIES_SUCCESS_TYPE = typeof LOAD_MOVIES_SUCCESS;
export const UPDATE_MOVIES_OPTIMISTIC = "UPDATE_MOVIES_OPTIMISTIC";
export type UPDATE_MOVIES_OPTIMISTIC_TYPE = typeof UPDATE_MOVIES_OPTIMISTIC;
export const ADD_MOVIE_SUCCESS = "ADD_MOVIE_SUCCESS";
export type ADD_MOVIE_SUCCESS_TYPE = typeof ADD_MOVIE_SUCCESS;
export const DELETE_MOVIE_OPTIMISTIC = "DELETE_MOVIE_OPTIMISTIC";
export type DELETE_MOVIE_OPTIMISTIC_TYPE = typeof DELETE_MOVIE_OPTIMISTIC;
export const API_CALL_ERROR = "API_CALL_ERROR";
export type API_CALL_ERROR_TYPE = typeof API_CALL_ERROR;
export const HIDE_MODAL = "HIDE_MODAL";
export type HIDE_MODAL_TYPE = typeof HIDE_MODAL;
export const SHOW_MODAL = "SHOW_MODAL";
export type SHOW_MODAL_TYPE = typeof SHOW_MODAL;
export const BEGIN_API_CALL = "BEGIN_API_CALL";
export type BEGIN_API_CALL_TYPE = typeof BEGIN_API_CALL;
export const CLEAN_ERROR = "CLEAN_ERROR";
export type CLEAN_ERROR_TYPE = typeof CLEAN_ERROR;